import $ from "jquery"
window.$ = $
window.jQuery = $

import {Predefs, GetPredefs} from "../lib/predefs";

$(document).ready(function() {
    GetPredefs();
    $('#sendAttendeeResponseBtn').click(function() {
        let progressModal = $('#responseProgressModal');
        M.Modal.getInstance($(progressModal)).open();

        let calendarID = $('#calendarIdField').val();
        let eventID = $('#eventIdField').val();

        let params = {
            attendee_id: parseInt($('#attendeeIdField').val()),
            security_token: $('#securityTokenField').val(),
            declined_reason: $('#declinedReasonArea').val(),
        };

        $.ajax(Predefs.links.backend_url + "/calendar/" + calendarID + "/events/" + eventID + "/reason", {
            method: "POST",
            data: JSON.stringify(params),
            success: function (data) {
                M.Modal.getInstance($(progressModal)).close();
                M.Modal.getInstance($('#successModal')).open();
            },
            error: function () {
                M.Modal.getInstance($(progressModal)).close();
                M.Modal.getInstance($('#errorMessageModal')).open();
            }
        })
    })
});
